// extracted by mini-css-extract-plugin
export default {"container":"styles_container__+uVSU","twoButtons":"styles_twoButtons__XLc7I"};